import * as DOMHelper from 'dom-lib';
export var dispalyName = 'DOMHelper';
export default DOMHelper;